module.exports = __webpack_public_path__ + "pintora/recurrent-877633005dc676d2.svg";